import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { PasswordResetModel } from './password-reset/password-reset-model';

const API_ENDPOINT = '/api/password/';

@Injectable({
  providedIn: 'root',
})
export class PasswordService {
  /**
   * Constructor
   *
   * @param http
   */
  public constructor(private http: HttpClient) { }

  /**
   * Send the password forgot request
   *
   * @param email
   *
   * @return Observable<any>
   */
  public sendPasswordForgot(email: string): Observable<any> {
    return this.http.post(API_ENDPOINT + 'forgot', {
      email: email,
    }).pipe(
      map((response: Response) => {
        return response;
      }),
      catchError((error) => {
        return throwError(() => error);
      }),
    );
  }

  /**
   * Check if the request is allowed to access the reset form
   *
   * @param hash
   * @param token
   */
  public canResetPassword(hash: string, token: string): Observable<boolean> {
    return this.http.post(API_ENDPOINT + 'valid/token', {
      hash: hash,
      token: token,
    }).pipe(
      map(() => {
        return true;
      }),
      catchError((error) => {
        return throwError(() => error);
      }),
    );
  }

  /**
   * Send Password Reset Information
   *
   * @param passwordReset
   */
  public sendPasswordReset(passwordReset: PasswordResetModel): Observable<any> {
    return this.http.post(API_ENDPOINT + 'reset', {
      hash: passwordReset.hash,
      token: passwordReset.token,
      email: passwordReset.email,
      password: passwordReset.password,
      password_confirmation: passwordReset.passwordConfirmation,
    });
  }
}
